const getCropThumbController = () => import('../../dialogs/crop-thumb/crop-thumb-dialog.controller')

/* @ngInject */
function InputCampaignThumbController ($scope, ModalService, Utils, AttachmentService, AssetService) {
  $scope.loading = false
  $scope.showError = false
  $scope.croppedImage = ''

  let oldModalReference
  let thumbnail = []

  const api = {
    _urlToFile,
    _attachFile,
    _getThumbUrl
  }
  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.attach = function (file) {
    if (!file) {
      return
    }

    oldModalReference = ModalService.getCurrentModal()
    let image
    $scope.profileImageFile = file

    const reader = new FileReader()
    reader.onload = function (event) {
      $scope.$apply(function () {
        image = event.target.result

        getCropThumbController().then(({ CropThumbController }) => {
          ModalService.showModal({
            templateId: 'cropThumb.html',
            templateUrl: '/admin/dialogs/crop-thumb/crop-thumb-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            appendElement: $('.create-campaign-dialog'),
            controller: CropThumbController,
            data: {
              image
            }
          }).then(croppedImage => {
            if (oldModalReference) {
              ModalService.setCurrentModal(oldModalReference)
              ModalService.showCurrentModal()
            }
            if (croppedImage) {
              api._urlToFile(croppedImage, $scope.profileImageFile.name, $scope.profileImageFile.type).then(file => {
                $scope.file = file
                api._attachFile(file)
              })
            }
          })
        })
      })
    }
    reader.readAsDataURL(file)
  }

  $scope.tryAgainClick = function () {
    $scope.showError = false
  }

  function _urlToFile (url, filename, mimeType) {
    return Utils.urlToFile(url, filename, mimeType)
  }

  function _attachFile (file) {
    try {
      $scope.$emit('campaign.uploadingThumbnail')

      thumbnail = []

      AttachmentService.attach([file], thumbnail, [],
        (oRes) => {
          if (oRes.value) {
            $scope.croppedImage = oRes.value[0]
          }
          $scope.loading = true
        },
        () => {
          $scope.loading = false
          api._getThumbUrl($scope.croppedImage)
          $scope.$emit('campaign.thumbnailCropped', file)
        })
    } catch (e) {
      $scope.showError = true
    }
  }

  function _getThumbUrl (id) {
    $scope.thumbUrl = AssetService.getFileUrlThumbnail(id)
  }

  $scope.calculateSvgLoaderProgress = function (loaded) {
    if (!loaded) {
      return 240
    }
    return 240 - loaded * 2.4
  }

  $scope.tryAgainClick = function () {
    $scope.showError = false
  }
}

export { InputCampaignThumbController }
